<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" :width="dialogWidth" :scrollable="true">
        <v-card>
          <v-card-title class="headline">{{$t('payoutAccountDetailsDialog.title')}}</v-card-title>
          <v-card-text>
            <div class="mt-1 mb-3">
              <account-widget :account="account"/>
            </div>
            <div v-if="account.confirmed == false">
              <info-block icon="mdi-alert" style="color: var(--v-warning-base);"><span>{{$t('payoutAccountDetailsDialog.not-confirmed-yet')}}</span></info-block>
              <v-btn :disabled="loading" color="error" @click="deleteAccount" class="mt-4">
                <v-icon left>mdi-delete</v-icon>{{$t('payoutAccountDetailsDialog.delete-account')}}
              </v-btn>
            </div>
            <div v-else>
              <info-block style="color: var(--v-success-base);"><span>{{$t('payoutAccountDetailsDialog.confirmed')}}</span></info-block>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-flex>
              <v-btn :disabled="loading" color="primary" @click="closeDialog()" class="me-2 mb-2">
                <v-icon left>mdi-close-circle</v-icon>{{$t('common.close')}}
              </v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {EVENT_BANK_ACCOUNTS_CHANGED} from "@/plugins/eventbus"
import { MUTATION_RAISE_NOTIFICATION } from "@/plugins/store";
import InfoBlock from '../InfoBlock.vue';
import AccountWidget from "./AccountWidget"

export default {
  name: "AccountDetailsDialog",
  mixins: [],
  components: {
    AccountWidget,
    InfoBlock,
  },
  props: {
    account: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
    changeAction: {
      type: Function,
      required: false,
    },
    closeAction: {
      type: Function,
      required: true
    },
  },
  data: function() {
    return {
      dialog: false,
      loading: false,
      valid: false,
    };
  },
  computed: {
    dialogWidth: function() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "500";
      } else if (this.$vuetify.breakpoint.smAndUp) {
        return "80%";
      }
      return "90%";
    },
  },
  watch: {
    visible: function(val) {
      // console.log('visible changed to ' + val)
      this.dialog = val;
    },
    dialog: function(val) {
      // console.log("dialog changed to " + val);
      if (val === false) {
        this.closeAction();
      }
    },
  },
  mounted() {
    this.dialog = this.visible
  },
  methods: {
    closeDialog() {
      this.closeAction();
    },
    emitChangeAction() {
      this.changeAction && this.changeAction({account: this.account});
    },
    deleteAccount() {
      this.loading = true
      this.$api.deleteBankAccount(this.account.uid)
      .then(() => {
        this.loading = false
        let msg = this.$t('payoutAccountDetailsDialog.account-deleted-successful', {account: this.account.name})
        this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            type: "success",
            message: msg
        });
        this.emitChangeAction()
        this.$eventBus.$emit(EVENT_BANK_ACCOUNTS_CHANGED)
        this.closeDialog()
      })
      .catch(error => {
        this.loading = false
        this.$common.onError(error)
      })
    }
  }
};
</script>
